namespace RioERP.Masters {
    export interface AttemptsRow {
        Id?: number;
        Name?: string;
        AttemptDate?: string;
        CourseId?: number;
        LevelId?: number;
        IsActive?: boolean;
        CourseName?: string;
        CourseIsActive?: boolean;
        CourseInsertUserId?: number;
        CourseInsertDate?: string;
        CourseUpdateUserId?: number;
        CourseUpdateDate?: string;
        LevelName?: string;
        LevelCourseId?: number;
        LevelIsActive?: boolean;
        LevelInsertUserId?: number;
        LevelInsertDate?: string;
        LevelUpdateUserId?: number;
        LevelUpdateDate?: string;
        InsertUserId?: number;
        InsertDate?: string;
        UpdateUserId?: number;
        UpdateDate?: string;
    }

    export namespace AttemptsRow {
        export const idProperty = 'Id';
        export const nameProperty = 'Name';
        export const localTextPrefix = 'Masters.Attempts';
        export const lookupKey = 'Masters.Attempts';

        export function getLookup(): Q.Lookup<AttemptsRow> {
            return Q.getLookup<AttemptsRow>('Masters.Attempts');
        }
        export const deletePermission = 'Masters:MastersManagement:Modify';
        export const insertPermission = 'Masters:MastersManagement:Modify';
        export const readPermission = 'Masters:MastersManagement:View';
        export const updatePermission = 'Masters:MastersManagement:Modify';

        export declare const enum Fields {
            Id = "Id",
            Name = "Name",
            AttemptDate = "AttemptDate",
            CourseId = "CourseId",
            LevelId = "LevelId",
            IsActive = "IsActive",
            CourseName = "CourseName",
            CourseIsActive = "CourseIsActive",
            CourseInsertUserId = "CourseInsertUserId",
            CourseInsertDate = "CourseInsertDate",
            CourseUpdateUserId = "CourseUpdateUserId",
            CourseUpdateDate = "CourseUpdateDate",
            LevelName = "LevelName",
            LevelCourseId = "LevelCourseId",
            LevelIsActive = "LevelIsActive",
            LevelInsertUserId = "LevelInsertUserId",
            LevelInsertDate = "LevelInsertDate",
            LevelUpdateUserId = "LevelUpdateUserId",
            LevelUpdateDate = "LevelUpdateDate",
            InsertUserId = "InsertUserId",
            InsertDate = "InsertDate",
            UpdateUserId = "UpdateUserId",
            UpdateDate = "UpdateDate"
        }
    }
}
